import {UserSettings} from './user-settings.model';

export interface UserModel {
  firstName: string;
  userName: string;
  lastName: string;
  mdmId?: number;
  middleName?: string;
  incomm?: boolean;
  groups?: string[];
}

/**
 * Model, descripting current logged in user
 */
export interface SystemUserModel {
  userName: string;
  firstName: string;
  lastName: string;
  substitutedUsers: string[];
  settings: UserSettings;
}

export enum UserTheme {
  'LIGHT' = 'LIGHT',
  'DARK' = 'DARK',
}
